import React, {useMemo} from 'react';
import {useParams} from 'react-router-dom';

const SCSCV_ORIGIN = 'http://scs.sh.cn';

export default function ScscvIframeShell() {
  const {scscvPath} = useParams<{scscvPath: string}>();

  const src = useMemo(() => {
    if (!scscvPath || scscvPath.includes('..')) {
      return '';
    }
    const segment = encodeURIComponent(scscvPath);
    return `${SCSCV_ORIGIN}/scscv/${segment}/index.html`;
  }, [scscvPath]);

  if (!src) {
    return null;
  }

  return (
    <iframe
      title="上海市计算机学会计算机视觉专委会"
      src={src}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        border: 'none',
        margin: 0,
        padding: 0,
        display: 'block',
      }}
    />
  );
}
